import React, { useState, useEffect } from "react";
import { api_url } from "../../constant/constant";
import { showToast } from "../../Components/ShowToast/ToastNotification";
import { useTranslation } from "react-i18next";

const AttachbyuserfilterPhishingcampaign = () => {
  const { t } = useTranslation();

  const [departments, setDepartments] = useState([]);
  const [phishingCampaigns, setPhishingCampaigns] = useState([]);
  const [learningCampaigns, setLearningCampaigns] = useState([]);

  const [relationDept, setRelationDept] = useState("OR"); // 🔹 Department relation fixed
  const [relationCampaigns, setRelationCampaigns] = useState(""); // 🔹 Phishing & Learning relation

  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedPhishing, setSelectedPhishing] = useState("");
  const [selectedLearning, setSelectedLearning] = useState("");

  const searchParams = new URLSearchParams(window.location.search);
  const LcUserModal_id = Number(searchParams.get("LcUserModal_id"));

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDepartments();
    fetchPhishingCampaigns();
    fetchAllCampaigns();
  }, []);

  // 🔹 Fetch Departments
  const fetchDepartments = async () => {
    try {
      const token = localStorage.getItem("userToken");
      const res = await fetch(`${api_url}/admin/main/departments`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();
      setDepartments(result.data || []);
    } catch (error) {
      showToast(t("fetcherror"), "error");
    }
  };

  // 🔹 Fetch Phishing Campaigns
  const fetchPhishingCampaigns = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("userToken");
      const res = await fetch(`${api_url}/phishing-campaigns`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await res.json();
      setPhishingCampaigns(result.data?.data || []);
    } catch (error) {
      showToast(t("errorfetchingphishingcampaigndata"), "error");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Fetch Learning Campaigns (all pages)
  const fetchAllCampaigns = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("userToken");
      let allCampaigns = [];
      let page = 1;
      let totalPages = 1;

      do {
        const response = await fetch(`${api_url}/learning-campaigns?page=${page}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const result = await response.json();
        const campaignData = result.learning_campaigns?.data || result.data?.data || [];
        allCampaigns = [...allCampaigns, ...campaignData];
        totalPages = result.learning_campaigns?.last_page || result.data?.last_page || 1;
        page++;
      } while (page <= totalPages);

      setLearningCampaigns(allCampaigns);
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      showToast(t("errorfetchingdata"), "error");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Handle Submit → API Call
  const handleSubmit = async () => {
    if (!selectedDepartment) return showToast(t("SelectDepartment"), "error");
    if (!selectedPhishing) return showToast(t("SelectPhishingCampaign"), "error");
    if (!selectedLearning) return showToast(t("SelectLearningCampaign"), "error");

    setLoading(true);
    try {
      const token = localStorage.getItem("userToken");

      // ✅ Payload exactly as required
      const payload = {
        primary_filter: {
          type: "by_department",
          value: selectedDepartment,
        },
        secondary_filters: [
          {
            type: "by_campaign",
            value: selectedLearning,
          },
          {
            type: "who_were_phished",
            value: selectedPhishing,
          },
        ],
        secondary_relation: relationCampaigns,
      };

      console.log("Payload Sent:", payload);

      const response = await fetch(
        `${api_url}/bulk-enrollment/phishing/${LcUserModal_id}/enroll-users`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        showToast(t("EnrollmentSuccessful"), "success");
        console.log("Response:", result);
      } else {
        showToast(result.message || t("SomethingWentWrong"), "error");
      }
    } catch (error) {
      console.error("Error:", error);
      showToast(t("NetworkError"), "error");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 UI Section
  return (
    <div className="container mt-4">
      <h3 className="mb-4">{t("AddUsersUsingQuery")}</h3>
      {loading && <p>{t("Loading...")}</p>}

      <div className="d-flex gap-3 mb-3 flex-wrap align-items-end">
        {/* Department */}
        <div className="flex-fill">
          <label className="form-label">{t("Department")}</label>
          <select
            className="form-select"
            value={selectedDepartment}
            onChange={(e) => setSelectedDepartment(e.target.value)}
          >
            <option value="">{t("SelectDepartment")}</option>
            {departments.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>
        </div>

        {/* Fixed Relation */}
        <div className="flex-fill" style={{ maxWidth: "100px" }}>
          <label className="form-label">{t("Relation")}</label>
          <select className="form-select" value={relationDept} disabled>
            <option value="OR">{t("OR")}</option>
          </select>
        </div>

        {/* Phishing Campaign */}
        <div className="flex-fill">
          <label className="form-label">{t("PhishingCampaign")}</label>
          <select
            className="form-select"
            value={selectedPhishing}
            onChange={(e) => setSelectedPhishing(e.target.value)}
          >
            <option value="">{t("SelectPhishingCampaign")}</option>
            {phishingCampaigns
              .filter((p) => p.id !== LcUserModal_id) // URL id wali campaign exclude
              .map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name_en || p.name_ar || p.name}
                </option>
              ))}
          </select>
        </div>

        {/* Relation between Phishing & Learning */}
        <div className="flex-fill" style={{ maxWidth: "150px" }}>
          <label className="form-label">{t("Relation")}</label>
          <select
            className="form-select"
            value={relationCampaigns}
            onChange={(e) => setRelationCampaigns(e.target.value)}
          >
            <option value="">{t("SelectRelation")}</option> {/* empty option */}
            <option value="AND">{t("AND")}</option>
            <option value="OR">{t("OR")}</option>
          </select>

        </div>

        {/* Learning Campaign */}
        <div className="flex-fill">
          <label className="form-label">{t("LearningCampaign")}</label>
          <select
            className="form-select"
            value={selectedLearning}
            onChange={(e) => setSelectedLearning(e.target.value)}
          >
            <option value="">{t("SelectLearningCampaign")}</option>
            {learningCampaigns.map((l) => (
              <option key={l.id} value={l.id}>
                {l.title_en || l.name || l.id}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Submit */}
      <button
        className="btn btn-success"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? t("Loading...") : t("Submit")}
      </button>
    </div>
  );
};

export default AttachbyuserfilterPhishingcampaign;
